import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { Pages } from "components/pages";

export default function VisitsRoute() {

    const { path } = useRouteMatch();
    
    return (
        <>
            <Switch>
                <Route path={`${path}`} exact>
                    <Pages.VisitsPage />
                </Route>
                <Route path={`${path}/page/:id`} exact>
                    <Pages.VisitsPage />
                </Route>
            </Switch>
        </>
    );

}